import { useContext } from 'react';

import { HelpPanelContext } from '../context/HelpPanelContext';

export const useHelpPanel = () => {
  const context = useContext(HelpPanelContext);
  if (context === undefined) {
    throw new Error('useHelpPanel must be used within a HelpPanelProvider');
  }
  return context;
};
